import styled from 'styled-components';

export const DesktopListOnly = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const MobileCardList = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 14px;
  }
`;

export const MobileListCard = styled.article`
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.bgWhite};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  min-height: 52px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 13px 14px 11px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
`;

export const MobileCardHeading = styled.div`
  min-width: 0;
  flex: 1;
`;

export const MobileCardTitle = styled.h2`
  margin: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.text};
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
`;

export const MobileCardSubtitle = styled.p`
  margin: 3px 0 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 11px;
  line-height: 1.45;
`;

export const MobileCardStatus = styled.div`
  display: inline-flex;
  min-height: 28px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: ${({ theme }) => theme.radius.full};
  background: ${({ theme }) => theme.colors.borderLight};
  white-space: nowrap;
`;

export const MobileCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 14px;
  padding: 13px 14px;
`;

export const MobileCardField = styled.div`
  min-width: 0;
  grid-column: ${({ $wide }) => ($wide ? '1 / -1' : 'auto')};
`;

export const MobileCardLabel = styled.div`
  margin-bottom: 3px;
  color: ${({ theme }) => theme.colors.textLight};
  font-size: 10px;
  font-weight: 600;
`;

export const MobileCardValue = styled.div`
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.colors.text};
  font-size: 13px;
  line-height: 1.5;
`;

export const MobileCardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};

  > button, > a {
    min-height: 40px;
  }
`;

export const MobileCardSelect = styled.label`
  display: inline-flex;
  min-height: 40px;
  margin-right: auto;
  align-items: center;
  gap: 7px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 12px;
  cursor: pointer;

  input {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const MobileListState = styled.div`
  padding: 42px 20px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.bgWhite};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 13px;
  text-align: center;
`;
